import React, { useState } from "react";
import { useSelector } from "react-redux";
import "../assets/css/sidebar.css";
import { RootState } from "../reduxToolkit/store";
import Breadcrumb from "./Breadcrumb";
import Sidebar from "./Sidebar";

interface LayoutWrapperProps {
  children: React.ReactNode;
}

const LayoutWrapper: React.FC<LayoutWrapperProps> = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const isAuthenticated = useSelector(
    (state: RootState) => state.auth.isAuthenticated
  );
  const userRole = useSelector((state: RootState) => state.auth.userRole) ?? "";

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  // Check if user has access to admin features
  const hasAdminAccess = [
    "Administrator",
    "RMCAdmin",
    "RMCUser",
    "Consultant",
  ].includes(userRole);

  if (!isAuthenticated || !hasAdminAccess) {
    // For non-authenticated users or users without admin access, just show content
    return <div className="app-content">{children}</div>;
  }

  return (
    <div className="app-layout">
      {/* Sidebar */}
      <Sidebar isOpen={sidebarOpen} onToggle={toggleSidebar} />

      {/* Main Content */}
      <div className={`app-content ${sidebarOpen ? "with-sidebar" : ""}`}>
        {/* Global breadcrumb restored (always visible beneath navbar) */}
        <Breadcrumb />

        {children}
      </div>
    </div>
  );
};

export default LayoutWrapper;
